export const isWallboxConsumerLine = (traceName: string): boolean => {
  return traceName.startsWith('Wallbox') && !traceName.includes('Discharged')
}

export const isConsumerLine = (traceName: string): boolean => {
  return (
    traceName === 'ConsumptionHouse' ||
    isWallboxConsumerLine(traceName) ||
    traceName.startsWith('Powermeter_NetOut') ||
    traceName.startsWith('Powermeter_consumption')
  )
}

export const isProducerLine = (traceName: string): boolean => {
  return (
    traceName.startsWith('DC_PowerSolar') ||
    traceName.startsWith('Powermeter_NetIn') ||
    traceName.startsWith('Powermeter_production') ||
    traceName.startsWith('Wallbox_energyDischarged')
  )
}
